module.exports = __webpack_public_path__ + "static/media/pound.9be8b735.svg";